export const DEFAULT_COUNTRY_BG = 'bg';
